import React from "react";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {Button} from "../../../../../../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../../../../../../react-hooks/use-services.hook";
import {CyClass} from "../../../../../../../../../common/cy-classes";

export const GamePlayPcHeaderBarAddFundsButtonComponent: React.FC<{gameContext: IGameContextViewModel}> = observer((props) => {
    const services = useServices();
    if(!props.gameContext.supportsAddInGameFunds) {
        return null;
    }

    const onClickHandler = async () => {
        services.analytics.sendOrbitUserFlowEvent("Navigation", "AddFunds", "GameHeader");
        await props.gameContext.addInGameFunds({
            isCalledFromCashierClose: false
        });
    }

    return (
        <Button
            preset="secondary"
            onClick={onClickHandler}
            className={CyClass('cy-add-funds-button')}
            sizeVariant="m"
            icon={{Component: services.theme.currentTheme.icons.addFundsIcon}}
        >
            {services.translation.translate('ADD_FUNDS_GAME_HEADER_BUTTON')}
        </Button>
    );
})